import React, {Component, ReactElement, ReactNode} from 'react'
import {
    INFOMATION_TYPE,
    MANAGEMENT_CATEGORY,
    MANSION_CATEGORY,
    MESSAGE_TYPE,
    VISITORS_RANGE,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate';
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons';
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links';
import {formatForDateInput} from '../../../formatters/formatDate';
import {Box, Link, Table, TableBody, TableCell, TableRow} from '@mui/material';
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent';
import NatApartAssocInfoRepo from './repository/NatApartAssocInfoRepo';
import {NatDeleteApartAssocInfo} from './repository/NatDeleteApartAssocInfo'
import {NatGetApartAssocInfo, PublishMaterialInfo} from './repository/NatGetApartAssocInfo'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {Messages} from '../../../Messages'
import {isIE} from 'react-device-detect'
import {Location} from 'react-router-dom'

const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'

interface Props {
    apartAssocInfoRepo: NatApartAssocInfoRepo
    apartAssocId: string
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    title: string
    infoCategoryId: string
    categoryId: string
    sortOrder: number
    publishStartDate: string
    publishEndDate: string
    browseAuthority: string
    publishFile: PublishMaterialInfo[]
    isLoadCompleted: boolean
}


class NatAdminApartAssocInfoDetailsPage extends Component<Props & AdminPagePropsSet, States> {
    mode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.mode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)

        this.state = {
            title: '',
            infoCategoryId: '',
            categoryId: '',
            sortOrder: 0,
            publishStartDate: '',
            publishEndDate: '',
            browseAuthority: '',
            publishFile: [],
            isLoadCompleted: false,
        }
        this.backApartAssocListLinkClick = this.backApartAssocListLinkClick.bind(this)
        this.editApartAssocLinkClick = this.editApartAssocLinkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleDeleteOkClick = this.handleDeleteOkClick.bind(this)
        this.deletAapartAssoc = this.deletAapartAssoc.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const apartAssoc: Nullable<NatGetApartAssocInfo> = await this.props.asyncCallFunction(
                this.props.apartAssocInfoRepo.getApartAssocInfo.bind(
                    this.props.apartAssocInfoRepo, this.props.apartAssocId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (apartAssoc && apartAssoc.details) {
                this.setState({
                    title: apartAssoc.details.title,
                    infoCategoryId: apartAssoc.details.infoCategoryId,
                    categoryId: apartAssoc.details.categoryId,
                    sortOrder: apartAssoc.details.sortOrder,
                    publishStartDate: apartAssoc.details.publishStartDate,
                    publishEndDate: apartAssoc.details.publishEndDate,
                    browseAuthority: apartAssoc.details.browseAuthority,
                    publishFile: apartAssoc.details.publishMaterialInfo,
                    isLoadCompleted: true,
                })
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    backApartAssocListLinkClick(): void {
        this.props.navigate(`/admin/apartAssocList`)
    }

    editApartAssocLinkClick(): void {
        this.props.navigate(`/admin/apartAssocEdit/${this.props.apartAssocId}`)
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleDeleteOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            const deleteApartAssocInfoResponse: Nullable<NatDeleteApartAssocInfo> = await this.props.asyncCallFunction(
                this.props.apartAssocInfoRepo.deleteApartAssocInfo.bind(
                    this.props.apartAssocInfoRepo, this.props.apartAssocId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (deleteApartAssocInfoResponse && deleteApartAssocInfoResponse.requestError === null) {
                this.props.navigate(`/admin/apartAssocList`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0006.toString('マンション・管理組合情報', this.state.title),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    getDisplayInfomationLabel(infoCategoryId: string): string {
        const infomaionLabel =
            INFOMATION_TYPE.codeToEnumConstants(infoCategoryId)
        if (infomaionLabel) {
            return infomaionLabel.label
        } else {
            return ''
        }
    }

    getCategoryLabel(infoCategoryId: string, categoryId: string): string {
        if (infoCategoryId === INFOMATION_TYPE.APART_INFO.value) {
            const categoryLabel = MANSION_CATEGORY.codeToEnumConstants(categoryId)
            if (categoryLabel) {
                return categoryLabel.label
            } else {
                return ''
            }
        } else {
            const categoryLabel = MANAGEMENT_CATEGORY.codeToEnumConstants(categoryId)
            if (categoryLabel) {
                return categoryLabel.label
            } else {
                return ''
            }
        }
    }

    getDisplayVisitorsLabel(visitors: string): string {
        const visitorsLabel =
            VISITORS_RANGE.codeToEnumConstants(visitors)
        if (visitorsLabel) {
            return visitorsLabel.label
        } else {
            return ''
        }
    }

    getPublishEndDate(publishEndDate: string): string {
        if (publishEndDate != null) {
            return formatForDateInput(publishEndDate)
        } else {
            return publishEndDate
        }
    }

    async deletAapartAssoc(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0011.errorLevel,
                message: Messages.IOPCC0011.toString(this.state.title),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleDeleteOkClick,
                    },
                ],
            },
        )
    }

    renderApartAssocTable(): ReactNode {
        return <>
            <Table>
                <StyledTableCaption>マンション・管理組合情報</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowName>情報種別</TableRowName>
                        <TableCell colSpan={4}>
                            {this.getDisplayInfomationLabel(this.state.infoCategoryId)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>カテゴリー</TableRowName>
                        <TableCell colSpan={4}>
                            {this.getCategoryLabel(this.state.infoCategoryId, this.state.categoryId)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>タイトル</TableRowName>
                        <TableCell colSpan={4}>
                            {this.state.title}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>掲載開始日</TableRowName>
                        <TableCell colSpan={4}>
                            {`${formatForDateInput(this.state.publishStartDate)}`}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>掲載終了日</TableRowName>
                        <TableCell colSpan={4}>
                            {this.getPublishEndDate(this.state.publishEndDate)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>並び順</TableRowName>
                        <TableCell colSpan={4}>
                            {this.state.sortOrder}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>閲覧者</TableRowName>
                        <TableCell colSpan={4}>
                            {this.getDisplayVisitorsLabel(this.state.browseAuthority)}
                        </TableCell>
                    </TableRow>
                    {(this.state.publishFile.length > 0) ?
                        this.state.publishFile.map((publishFile, index) => (
                            <TableRow key={'publishFile_' + publishFile.fileNumber}>
                                {index === 0 &&
                                    <TableRowName rowSpan={this.state.publishFile.length}>掲載資料</TableRowName>
                                }
                                <TableCell>
                                    {(isIE) ?
                                        <Link
                                            onClick={() => window.open(publishFile.path)}
                                            target={'_blank'}
                                            underline="hover">
                                            <img src={`/resources/images/icons/icon_pdf.png`}
                                                 alt=""/>
                                        </Link> :
                                        <Link href={publishFile.path} target={'_blank'} underline="hover">
                                            <img src={`/resources/images/icons/icon_pdf.png`}
                                                 alt=""/>
                                        </Link>
                                    }

                                </TableCell>
                                <TableCell>
                                    {publishFile.publishMaterialName}
                                </TableCell>
                                <TableCell>並び順 {publishFile.sortOrder}</TableCell>
                            </TableRow>
                        )) : null
                    }
                </TableBody>
            </Table>
        </>
    }

    renderPageHeaderArea(): Nullable<ReactNode> {
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_APART_ASSOC_INFO}>
                    <PageFotterAreaRight>
                        <DeleteLink
                            onClick={this.deletAapartAssoc}>
                            マンション・管理組合情報を削除する
                        </DeleteLink>
                    </PageFotterAreaRight>
                    <PageFotterAreaLeft>
                        <AdminPrimaryButton
                            onClick={this.editApartAssocLinkClick}>
                            編集する
                        </AdminPrimaryButton>
                    </PageFotterAreaLeft>
                </AuthorityChecker>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backApartAssocListLinkClick}
                    >
                        マンション・管理組合情報検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <Box mb={'15px'}>
                    <PageFooterArea>
                        {this.renderPageHeaderArea()}
                    </PageFooterArea>
                </Box>
                <Box mb={'15px'}>
                    <PageMainArea>
                        {this.renderApartAssocTable()}
                    </PageMainArea>
                </Box>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminApartAssocInfoDetailsPage)
